import React, { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { supabase } from "../lib/supabase";

export default function NewsletterDisiscrivi() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") || "";
  const [status, setStatus] = useState("idle"); // idle | loading | done | error
  const [errorMsg, setErrorMsg] = useState("");

  const handleUnsubscribe = async () => {
    setStatus("loading");
    setErrorMsg("");
    try {
      const { data, error } = await supabase.functions.invoke("newsletter-unsubscribe", {
        body: { email },
      });
      if (error) throw error;
      if (data?.error) throw new Error(data.error);
      setStatus("done");
    } catch (err) {
      setErrorMsg(err.message || "Qualcosa è andato storto. Riprova più tardi.");
      setStatus("error");
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-16 relative">
      <div className="absolute inset-0 grid-pattern opacity-30" />
      <div className="relative w-full max-w-md">
        <div className="text-center mb-10">
          <div className="text-overline text-yellow-400 mb-3">// Newsletter</div>
          <h1 className="font-display font-black text-4xl uppercase tracking-tight">Disiscrizione</h1>
        </div>

        <div className="rounded-2xl bg-zinc-900 border border-zinc-800 p-8 text-center space-y-5">
          {!email ? (
            <>
              <p className="text-zinc-300">
                Link non valido: manca l'indirizzo email da disiscrivere.
              </p>
              <Link to="/" className="text-yellow-400 font-semibold hover:underline text-sm">
                Torna al sito
              </Link>
            </>
          ) : status === "done" ? (
            <>
              <div className="text-yellow-400 text-4xl mb-2">✓</div>
              <h2 className="font-display font-bold text-xl uppercase mb-1">Disiscritto</h2>
              <p className="text-zinc-400 text-sm">
                <span className="text-zinc-200">{email}</span> non riceverà più le nostre comunicazioni.
              </p>
              <Link to="/" className="inline-block text-yellow-400 font-semibold hover:underline text-sm mt-2">
                Torna al sito
              </Link>
            </>
          ) : (
            <>
              <p className="text-zinc-300">
                Vuoi disiscrivere <span className="text-zinc-100 font-semibold">{email}</span> dalla newsletter dell'ASD Rubiana Calcio?
              </p>

              {status === "error" && (
                <div className="rounded-lg bg-red-500/10 border border-red-500/40 px-4 py-3 text-sm text-red-300 text-left">
                  {errorMsg}
                </div>
              )}

              <button
                onClick={handleUnsubscribe}
                disabled={status === "loading"}
                className="w-full py-2 px-4 rounded-full bg-yellow-400 text-zinc-950 font-display font-bold hover:bg-yellow-300 transition-colors disabled:opacity-60"
              >
                {status === "loading" ? "Disiscrizione…" : "Conferma disiscrizione"}
              </button>

              <Link to="/" className="block text-zinc-500 hover:text-zinc-300 text-sm">
                Annulla, torna al sito
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}